import React from 'react';

const Page = React.lazy(() => import('./ChildContractReportPage'));

const ChildContractReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/child-contracts',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default ChildContractReportConfig;
